/* eslint-disable no-param-reassign,no-restricted-syntax */
const convertProcessesToEventJSON = processes => {
  const newProcesses = JSON.parse(JSON.stringify(processes)).map(process => {
    const { choices } = process;
    const newChoices = choices.map(choice => {
      const { results, choicePropertyChipState } = choice;

      if (choicePropertyChipState && choicePropertyChipState.requiredSponsorCookie) {
        choice.requiredSponsorCookie = parseInt(choicePropertyChipState.requiredSponsorCookie, 10);
      }

      const resultSelect = {
        normal: {
          resultId: results.length - 1,
        },
        probs: [],
        ifs: [],
      };

      let totalProbability = 0;
      let calcultedValue = 0;

      // 1 totalProbability를 구한다. json 에 있는 prob의 합이다.

      for (const result of results) {
        const findIndex = results.findIndex(v => v.resultId === result.resultId);
        const { probability, requiredItems } = result;
        calcultedValue = totalProbability ? Math.floor((probability * 100) / (100 - totalProbability)) : probability;
        totalProbability += calcultedValue;
        if (probability) {
          resultSelect.probs.push({
            prob: calcultedValue,
            resultId: findIndex,
          });
        }

        if (requiredItems?.length > 0) {
          // const items = resultPropertyChipState.requiredItems.split(',').map(item => item.trim());

          // items.forEach(item => {
          //   itemCounts[item] = (itemCounts[item] || 0) + 1;
          // });

          // const itemsArray = Object.keys(itemCounts).map(name => ({
          //   name,
          //   count: itemCounts[name],
          // }));
          // console.log('itemsArray:', itemsArray);
          resultSelect.ifs.push({
            type: 'and',
            items: requiredItems,
            normal: {
              resultId: findIndex,
            },
          });
        }
      }

      choice.resultSelect = resultSelect;
      return choice;
    });
    process.choices = newChoices;
    return process;
  });
  return JSON.stringify(newProcesses);
};

export default convertProcessesToEventJSON;

// /* eslint-disable no-param-reassign,no-restricted-syntax */
// const convertProcessesToEventJSON = processes => {
//   const newProcesses = JSON.parse(JSON.stringify(processes)).map(process => {
//     const { choices } = process;
//     console.log('process:', process);
//     const newChoices = choices.map(choice => {
//       const { results, choicePropertyChipState } = choice;

//       if (choicePropertyChipState && choicePropertyChipState.requiredSponsorCookie) {
//         choice.requiredSponsorCookie = parseInt(choicePropertyChipState.requiredSponsorCookie, 10);
//       }

//       const resultSelect = {
//         normal: {
//           resultId: results.length - 1,
//         },
//         probs: [],
//         ifs: [],
//       };

//       let totalProbability = 0;
//       let calcultedValue = 0;

//       // 1 totalProbability를 구한다. json 에 있는 prob의 합이다.

//       for (const result of results) {
//         const findIndex = results.findIndex(v => v.resultId === result.resultId);
//         const { probability, resultPropertyChipState } = result;
//         console.log('result:', result);
//         calcultedValue = totalProbability ? Math.floor((probability * 100) / (100 - totalProbability)) : probability;
//         totalProbability += calcultedValue;
//         if (probability) {
//           resultSelect.probs.push({
//             prob: calcultedValue,
//             resultId: findIndex,
//           });
//         }

//         if (resultPropertyChipState.requiredItems) {
//           const items = resultPropertyChipState.requiredItems.split(',').map(item => item.trim());
//           const itemCounts = {};

//           items.forEach(item => {
//             itemCounts[item] = (itemCounts[item] || 0) + 1;
//           });

//           const itemsArray = Object.keys(itemCounts).map(name => ({
//             name,
//             count: itemCounts[name],
//           }));

//           resultSelect.ifs.push({
//             type: 'and',
//             items: itemsArray,
//             normal: {
//               resultId: findIndex,
//             },
//           });
//         }
//       }

//       choice.resultSelect = resultSelect;
//       return choice;
//     });
//     process.choices = newChoices;
//     return process;
//   });
//   return JSON.stringify(newProcesses);
// };

// export default convertProcessesToEventJSON;
